module.exports = __webpack_public_path__ + "no.0c98c480781d20d66aed.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/no.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/no.svg
// module chunks = styles